import { useQuery } from '@apollo/client';
import AuditModal from 'components/AuditTrack/AuditModal'
import { COMMITMENT_AUDIT } from 'graphql/audit';
import React from 'react'

const CommitmentsAudit = ({id, open, close, type}) => {
  const {data, loading} = useQuery(COMMITMENT_AUDIT, {
    variables: {
      id: id,
      type: type
    }
  })

  return (
    <AuditModal 
      data={data?.commitmentAudit || null}
      open={open}
      close={() => close()}
      isLoading={loading}
    />
  )
}

export default CommitmentsAudit